
import WidgetMixins from '../../../../mixins/WidgetMixins';
import DialogValidationMixin from '../../../../mixins/DialogValidationMixin';
import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import {
  IContact,
  IGroup,
  IGroupContact,
  IMessage,
  ISenderID,
  PayloadState,
} from '@/types/types';
const groupModule = namespace('group');
const smsModule = namespace('sms');
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, max } from 'vee-validate/dist/rules';
import DialogMixins from '@/mixins/DialogMixins';

extend('required', {
  ...required,
  message: 'Field is required',
});
extend('max', {
  ...max,
  message: 'Maximum characters must be 11',
});

@Component({
  name: 'SendSMSDialog',
  components: {
    ValidationProvider,
    ValidationObserver,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
})
export default class SendSMSDialog extends mixins(
  WidgetMixins,
  DialogMixins,
  DialogValidationMixin
) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @groupModule.Getter('getResetFormValues') resetFormValues!: IMessage;
  @groupModule.Getter('getGroupDetails') details!: IGroup;
  @smsModule.Getter('getSenderIDList') smsIDList!: Array<
    ISenderID & { uuid: string; id: number; slug: string }
  >;

  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) link!: string;
  @Prop({ default: 0 }) creditBalance!: number;
  @Prop({ default: [] }) groupContacts!: Array<IContact>;

  sms: IMessage = {
    to: '',
    from: '',
    message: '',
    type: 'Flash',
  };
  hint = '';
  totalCreditNeeded = 0;

  /* load the sender ID list on open; the host page does not always populate
     the store, which left the picker showing "No Sender ID Available" */
  @Watch('state')
  onDialogStateChange(isOpen: boolean): void {
    if (isOpen && this.smsIDList.length === 0) {
      this.$store.dispatch('sms/listSenderID', { isApproved: true });
    }
  }

  @Watch('groupContacts')
  onGroupDetailsChange(payload: Array<IContact>): void {
    this.sms.to = payload?.map((contact) => contact?.phone).join(',');
  }

  @Watch('resetFormState')
  onFormChange(payload: boolean): void {
    if (payload) {
      this.sms = { ...this.resetFormValues };
    } else this.$store.dispatch('resetFormValues', false, { root: true });
  }

  @Watch('sms.message')
  onMessageContentChange(content: string): void {
    this.totalCreditNeeded =
      Math.ceil(content?.length / 160) * (this.sms.to?.split(',').length ?? 1);
    this.hint = `${content?.length} words / ${this.totalCreditNeeded} sms unit`;
  }

  @Emit('sendSMS')
  sendSMS(): { body: IMessage; type?: string } {
    return { body: this.sms };
  }

  @Emit('actions')
  closeDialog(): PayloadState {
    return {
      idx: 'details',
      state: false,
    };
  }
}
